import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

type KlaviyoIDs = {
  displayName: string;
  desktop: string;
  mobile: string;
};

export default function addDefinitions(): boolean {
  try {
    // Only run on Medispa pages
    if (
      !document.body.classList.contains('template-medispa-v2') &&
      !document.body.classList.contains('template-medispa-overview-v2')
    ) {
      return false;
    }

    // Don't run on voucher page
    if (window.location.href.includes('/products/glamour-beauty-affairs-700-voucher')) {
      return false;
    }

    // Don't run on pages where window.theme.medispaCalendarConfig.products contains a product with pay_in_store = true
    const hasPayInStoreProduct = window.theme.medispaCalendarConfig.products.some(
      (product) => product?.pay_in_store === true,
    );

    if (hasPayInStoreProduct) {
      return false;
    }

    // Map of popup IDs to their desktop and mobile variants
    // Key is the market code (e.g. "zh-hans", "en"). "default" is used as a fallback
    const klaviyoFormMap = new Map<string, KlaviyoIDs>([
      [
        'zh-hans',
        {
          displayName: 'One-step email & SMS & Countdown - Simplified Chinese [Medispa]',
          desktop: 'UPDC65',
          mobile: 'TXGis2',
        },
      ],
      [
        'en',
        {
          displayName: 'One-step email & SMS & Countdown - English [Medispa]',
          desktop: 'YsxsFP',
          mobile: 'XWCm9d',
        },
      ],
      [
        'default',
        {
          displayName: 'One-step email & SMS & Countdown - Traditional Chinese [Medispa]',
          desktop: 'TZYBSb',
          mobile: 'R4Wkhs',
        },
      ],
    ]);

    const currentMarket = window.Shopify.routes.root.replace(/\//g, '');

    const klaviyoID = klaviyoFormMap.get(currentMarket) || klaviyoFormMap.get('default')!;

    const deviceType = matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoID[deviceType] });
    const popup = new Popup(adapter, {
      id: klaviyoID[deviceType],
      displayName: klaviyoID.displayName,
    });

    // window.popupMonitor.addPopup(popup);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
